export default __webpack_public_path__ + "static/107449-68095890bccfdd1e8eaddbe63c42e46a.jpg";